import type { NewsletterSignupEvent } from '../../../enums/Tracking';
import { NewsletterSignupName } from '../../../enums/Tracking';
import type { CampaignTrackingData } from '../../../tracking/campaignEventData';

export interface NewsletterTrackingData extends Pick<CampaignTrackingData, 'placement'> {
  name?: NewsletterSignupName;
  visitorHash?: string;
}

interface TrackingEventOptions {
  event: NewsletterSignupEvent;
  tracking?: NewsletterTrackingData;
  visitorHash?: string;
}

export const getTrackingData = ({ event, tracking, visitorHash }: TrackingEventOptions) => {
  const { visitorHash: trackingVisitorHash, ...rest } = tracking || {};
  const visitor_hash = visitorHash ? visitorHash : trackingVisitorHash;

  return {
    event,
    name: tracking?.name || NewsletterSignupName.NewsletterSignUp,
    ...(visitor_hash && { visitor_hash }),
    ...rest,
  };
};
